// modules/inicio/api/usuariosAPI.js
// Todas estas llamadas requieren sesión de admin (el backend las protege
// con verificarToken + verificarAdmin).

import axiosClient from "./axiosClient";

export async function listarUsuariosAPI() {
  const { data } = await axiosClient.get("/usuarios");
  return data;
}

export async function crearUsuarioAPI(usuario) {
  // usuario: { nombre, identificacion, numero_contrato, password, rol, programa }
  const { data } = await axiosClient.post("/usuarios", usuario);
  return data;
}

export async function actualizarUsuarioAPI(id, cambios) {
  const { data } = await axiosClient.put(`/usuarios/${id}`, cambios);
  return data;
}

export async function desactivarUsuarioAPI(id) {
  const { data } = await axiosClient.delete(`/usuarios/${id}`);
  return data;
}

// Aprueba una cuenta creada desde el registro público, fijando su rol y
// sus programas definitivos. body: { rol, programas }
export async function aprobarUsuarioAPI(id, { rol, programas }) {
  const { data } = await axiosClient.put(`/usuarios/${id}/aprobar`, { rol, programas });
  return data;
}

// Rechaza una solicitud de cuenta (no se borra — queda para auditoría).
export async function rechazarUsuarioAPI(id) {
  const { data } = await axiosClient.put(`/usuarios/${id}/rechazar`);
  return data;
}
